// 接口错误码不弹出Message的列表
export default [
  1101, //产品上线失败
  14004, // 用户存在，密码错误
  14012, // 用户不存在
  1104, //上传固件版本号过低
  1107, //上传设备ID文件错误
  14005, //token失效
  // 12002, // token is invalid
];

// const CODES = {
//   CODE_USER_NO_EXIST: 14012,
// };
// export default CODES
